import { Flex } from '@osmosis/react-ui/components/Box';
import { A } from '@osmosis/react-ui/components/Text';
import { P } from '@osmosis/react-ui/components/Text';
import React from 'react';
import { LoggedOutProductLibraryContainsItem } from '../../types/library';
import { formattedUrl } from '../../lib/library/format';
import { useLanguageContext } from '../../context/LanguageProvider';

type L3NoContainsProps = {
  l3: LoggedOutProductLibraryContainsItem;
};

/**
 * LibraryL3PageNoContainsLoggedOut.
 */
const LibraryL3PageNoContainsLoggedOut = (props: L3NoContainsProps) => {
  const { l3 } = props;
  const { activeLanguage } = useLanguageContext();

  return (
    <Flex
      pl={3}
      pt={2}
      pb={2}
      ml={3}
      flexDirection="column"
      width="90%"
      key={l3.name + l3.type}
      data-id={l3.name + l3.type}
      data-testid="library-topic-box-l3-no-contains-page"
      sx={{
        borderRadius: 5,
        ':hover': {
          color: 'blue',
          backgroundColor: 'bg-2',
        },
        transition: 'color 0.4s',
      }}
    >
      <A
        as="a"
        data-testid="library-topic-box-no-contains-l4-link"
        href={formattedUrl(l3.name, {
          language: activeLanguage,
        })}
        sx={{
          textDecoration: 'none',
        }}
      >
        <P
          p={0}
          color="gray70"
          fontWeight="body"
          fontSize={1}
          data-testid="l3-no-contains-page-name"
          sx={{
            ':hover': {
              color: 'blue',
            },
          }}
        >
          {l3.displayName || l3.name}
        </P>
      </A>
    </Flex>
  );
};

export default LibraryL3PageNoContainsLoggedOut;
